import React from 'react';
import { Link } from 'react-router-dom'
import why_work from '../../../assets/images/why-work.png';
import { Navigate } from 'react-router-dom';
import CustomModalView from '../../../common/input/customModal/customModalView';



const ForgotView = (props) => {
        return (
            <>
                <section className="login-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 login-center">
                                <div className="login-form-main">
                                    <div className="registration-form_wrapper">
                                        <div className="content">
                                            <img src={why_work} alt="" />
                                            <h3>carerconnect</h3>
                                            <h4>Whenever Wherever</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 login-center">
                                <div className="login-form">
                                    <h3>Forgot Password</h3>
                                    <form>
                                        <div className="field-box">
                                            <input onChange={(e) => props.handelData(e.target.value)} type="email" name="email" placeholder="Email Address" />
                                        </div>
                                        <div className="field-box">
                                            <button type="button" onClick={props.handelSummit} >Submit <i className="fa fa-sign-in"></i></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <CustomModalView
                    modal_show={props.modal_show}
                    authResponse = {props.authResponse}
                    showCustomModal= {props.showCustomModal}
                    hideCustomModal={props.hideCustomModal}
                    />
            </>
        )
    }


export default ForgotView;